import cookie from "react-cookies";
import {
  RIMS_COOKIE_STG_CONSTANTS,
  // RIMS_SESSION_STG_CONSTANTS,
} from "../constants";
import { getResolvedTenantId } from "../common/tenant";

export const useCookieData = () => {
  const token = cookie.load(RIMS_COOKIE_STG_CONSTANTS.LOGIN_TOKEN);
  const domain = cookie.load(RIMS_COOKIE_STG_CONSTANTS.DOMAIN);
  const tenantId = cookie.load(RIMS_COOKIE_STG_CONSTANTS.USER_TENANT_ID);
  const acTenantId = cookie.load(RIMS_COOKIE_STG_CONSTANTS.AC_TENANT_ID);
  const resolvedTenantId = getResolvedTenantId();
  const userId = cookie.load(RIMS_COOKIE_STG_CONSTANTS.USER_ID);
  const userInfo = cookie.load(RIMS_COOKIE_STG_CONSTANTS.USER_INFO);
  const userPrivileges = cookie.load(RIMS_COOKIE_STG_CONSTANTS.USER_PRIVILEGES);
  const userEmail = cookie.load(RIMS_COOKIE_STG_CONSTANTS.USER_EMAIL);
  const userName = cookie.load(RIMS_COOKIE_STG_CONSTANTS.USER_NAME);
  return {
    token,
    tenantId,
    acTenantId,
    resolvedTenantId,
    domain,
    userId,
    userInfo,
    userPrivileges,
    userEmail,
    userName,
  };
};
